import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';

import {headOption} from 'utils/common';

import arrowDown from 'assets/icons/arrow-down.svg';
import placeholderImage from 'assets/icons/placeholderImage.svg';

import Dropdown from 'components/Dropdown';

import {fetchLocations, selectLocations} from 'ducks/locations';
import {redirectToDefaultPage} from 'ducks/auth';

import {LocationSwitchListItem} from './components';

import './styles.css';

interface PassedProps {
  locationRef: string;
}

type LocationSwitchProps = PassedProps &
  ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps;

class LocationSwitch extends React.Component<LocationSwitchProps> {
  state = {
    position: {top: 0, left: 0},
    isActive: false
  };

  toggleDropdown = (event: React.MouseEvent) => {
    const position = event.currentTarget.getBoundingClientRect();

    this.setState({
      isActive: !this.state.isActive,
      position: {
        top: position.top + position.height,
        left: position.left
      }
    });
  };

  redirectToDefaultPage = ({locationRef}) => {
    this.props.redirectToDefaultPage({locationRef});
  };

  closeDropdown = () => {
    this.setState({isActive: false});
  };

  componentDidMount() {
    this.props.fetchLocations();
  }

  render() {
    const {locations, locationRef} = this.props;

    const location: any = headOption(
      locations.filter(({ref}) => ref === locationRef)
    );

    if (!location) {
      return null;
    }

    const selectedLocationImage =
      location.thumbnailImage || location.image || placeholderImage;

    return (
      <div className="LocationSwitch">
        <div
          className="LocationSwitch__container colab-sidepadding-2 colab-row-space-between colab-bold colab-clickable"
          onClick={this.toggleDropdown}
          data-dropdowntrigger="locationsSwitch">
          <div className="colab-centered">
            <img
              className="LocationSwitch__image"
              src={`${selectedLocationImage}?w=50&h=50&fit=crop`}
              alt=""
            />
            {location.name}
          </div>
          {locations.length > 1 && (
            <img src={arrowDown} alt="Change location" />
          )}
        </div>
        <Dropdown
          isOpen={locations.length > 1 && this.state.isActive}
          onClose={this.closeDropdown}
          position={this.state.position}
          triggerKey="locationsSwitch"
          appendToBody={true}>
          <div className="LocationSwitch__dropdown">
            {locations.map(location => (
              <LocationSwitchListItem
                location={location}
                selectedLocationRef={locationRef}
                onClick={() =>
                  this.redirectToDefaultPage({locationRef: location.ref})
                }
              />
            ))}
          </div>
        </Dropdown>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    locations: selectLocations(state)
  };
};

const mapDispatchToProps = {
  fetchLocations,
  redirectToDefaultPage
};

export default connect(mapStateToProps, mapDispatchToProps)(LocationSwitch);
